/**
 * Eldra Nuovi arrivi — frecce carosello desktop + hover card
 */
(() => {
  if (window.__eldraSpotlightCarouselBound) return;
  window.__eldraSpotlightCarouselBound = true;

  const reduceMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const bindTileHover = (section) => {
    if (!section || section.dataset.eldraSpotHover === '1') return;
    section.dataset.eldraSpotHover = '1';

    section.querySelectorAll('.eldra-spotlight-tile--alice').forEach((tile) => {
      if (tile.dataset.eldraHoverBound === '1') return;
      tile.dataset.eldraHoverBound = '1';
      tile.addEventListener('mouseenter', () => {
        tile.classList.add('is-hovered');
      });
      tile.addEventListener('mouseleave', () => {
        tile.classList.remove('is-hovered');
      });
    });
  };

  const init = (section) => {
    if (!section) return;
    bindTileHover(section);

    if (section.dataset.eldraSpotCarousel === '1') return;
    const track = section.querySelector('[data-eldra-spotlight-track]');
    const prev = section.querySelector('[data-eldra-spotlight-prev]');
    const next = section.querySelector('[data-eldra-spotlight-next]');
    if (!track || !prev || !next) return;
    section.dataset.eldraSpotCarousel = '1';

    const syncLeadHeight = () => {
      const lead = track.querySelector('.eldra-spotlight-lead');
      const tile = track.querySelector('.eldra-spotlight-tile--alice');
      if (!lead || !tile) return;
      lead.style.minHeight = `${Math.ceil(tile.getBoundingClientRect().height)}px`;
    };

    const followWrap = section.querySelector('[data-eldra-spotlight-follow-wrap]');
    const followCta = section.querySelector('[data-eldra-spotlight-follow-cta]');
    const leadEl = track.querySelector('.eldra-spotlight-lead');

    /* URL sicuro verso Nuovi arrivi (anche se Theme Editor ha link vuoto/#) */
    const resolveArriviUrl = () => {
      const fromCta = followCta?.getAttribute('href')?.trim();
      const fromLead = leadEl?.getAttribute('href')?.trim();
      const fromData = followCta?.dataset?.eldraSpotlightUrl?.trim();
      const candidate = fromData || fromCta || fromLead || '/collections/nuovi-arrivi';
      if (!candidate || candidate === '#' || candidate === '/') return '/collections/nuovi-arrivi';
      return candidate;
    };

    if (followCta) {
      const safeUrl = resolveArriviUrl();
      followCta.setAttribute('href', safeUrl);
      followCta.dataset.eldraSpotlightUrl = safeUrl;
      if (!followCta.getAttribute('aria-label')) {
        followCta.setAttribute('aria-label', 'Vai ai Nuovi arrivi');
      }
      if (followCta.dataset.eldraFollowNavBound !== '1') {
        followCta.dataset.eldraFollowNavBound = '1';
        followCta.addEventListener('click', (event) => {
          event.preventDefault();
          window.location.assign(resolveArriviUrl());
        });
      }
    }

    const setFollowVisible = (show) => {
      if (!followWrap) return;
      /* Non usare l'attributo HTML hidden: su iOS rompe tap/display. */
      followWrap.hidden = false;
      followWrap.classList.toggle('is-visible', show);
      followWrap.setAttribute('aria-hidden', show ? 'false' : 'true');
    };

    const syncFollowCta = () => {
      if (!leadEl || !followWrap) return;
      const leadRect = leadEl.getBoundingClientRect();
      const trackRect = track.getBoundingClientRect();
      /* Visibile se interseca ancora la zona prodotti (scroll orizzontale o verticale) */
      const overlapX = Math.min(leadRect.right, trackRect.right) - Math.max(leadRect.left, trackRect.left);
      const overlapY = Math.min(leadRect.bottom, trackRect.bottom) - Math.max(leadRect.top, trackRect.top);
      const visibleInTrack = overlapX > 28 && overlapY > 28;
      const visibleInViewport =
        leadRect.bottom > 48 &&
        leadRect.top < window.innerHeight - 48 &&
        leadRect.right > 12 &&
        leadRect.left < window.innerWidth - 12;
      setFollowVisible(!(visibleInTrack && visibleInViewport));
    };

    const getStep = () => {
      const tile =
        track.querySelector('.eldra-spotlight-tile') ||
        track.querySelector('.eldra-spotlight-lead');
      if (!tile) return Math.max(track.clientWidth * 0.8, 200);
      const gap = parseFloat(getComputedStyle(track).gap || '12') || 12;
      return tile.getBoundingClientRect().width + gap;
    };

    const syncNav = () => {
      const max = track.scrollWidth - track.clientWidth - 4;
      const left = track.scrollLeft;
      prev.hidden = left <= 4;
      next.hidden = left >= max;
      prev.disabled = left <= 4;
      next.disabled = left >= max;
    };

    const scrollByDir = (dir) => {
      track.scrollBy({
        left: dir * getStep(),
        behavior: reduceMotion() ? 'auto' : 'smooth',
      });
    };

    prev.addEventListener('click', () => scrollByDir(-1));
    next.addEventListener('click', () => scrollByDir(1));
    track.addEventListener(
      'scroll',
      () => {
        syncNav();
        syncFollowCta();
      },
      { passive: true }
    );
    window.addEventListener(
      'resize',
      () => {
        syncLeadHeight();
        syncNav();
        syncFollowCta();
      },
      { passive: true }
    );
    window.addEventListener('scroll', syncFollowCta, { passive: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncLeadHeight).catch(() => {});
    }
    if (leadEl && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        () => {
          syncFollowCta();
        },
        { root: track, threshold: [0, 0.08, 0.2, 0.5, 1] }
      );
      io.observe(leadEl);
      const ioView = new IntersectionObserver(() => syncFollowCta(), {
        root: null,
        threshold: [0, 0.1, 0.35],
      });
      ioView.observe(leadEl);
    }
    requestAnimationFrame(() => {
      syncLeadHeight();
      syncNav();
      syncFollowCta();
    });
    syncNav();
    syncFollowCta();
  };

  const boot = () => {
    document
      .querySelectorAll('.eldra-spotlight-strip--carousel, .eldra-spotlight-strip--products')
      .forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root =
      event.target?.querySelector?.('.eldra-spotlight-strip') || event.target;
    if (root?.classList?.contains('eldra-spotlight-strip')) {
      root.dataset.eldraSpotCarousel = '';
      root.dataset.eldraSpotHover = '';
      init(root);
    }
  });
})();
